import { render } from "./NewTrainingForm.vue?vue&type=template&id=6f254ed6&scoped=true"
import script from "./NewTrainingForm.vue?vue&type=script&lang=js"
export * from "./NewTrainingForm.vue?vue&type=script&lang=js"

import "./NewTrainingForm.vue?vue&type=style&index=0&id=6f254ed6&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f254ed6"]])

export default __exports__